module.exports = __webpack_public_path__ + "static/media/current-practice-icon.f7494142.svg";